import { PureComponent } from 'preact-compat'
import { editTags } from '@insided/shared/services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
// eslint-disable-next-line import/no-internal-modules
import PublicTagSelect from '@insided/deprecated-preact-components/public-tag/PublicTagSelect'

interface PublicTagsProps {
  onPublicTagsChanged: (newPublicTags: string[]) => void
  setIsLoading: (isLoading: boolean) => void
  publicTags: string[]
  contentType: ContentType
  privateId: number
}

class PublicTags extends PureComponent<PublicTagsProps> {
  constructor (props: PublicTagsProps) {
    super(props)
    this.onChangePublicTags = this.onChangePublicTags.bind(this)
  }

  async onChangePublicTags (newPublicTags: string[]) {
    const { contentType, privateId, onPublicTagsChanged, setIsLoading } = this.props
    setIsLoading(true)
    try {
      await editTags(contentType, privateId, newPublicTags)
      onPublicTagsChanged(newPublicTags)
    } finally {
      setIsLoading(false)
    }
  }

  render () {
    const { publicTags } = this.props
    return (
      <div className='topic-info__details-item'>
        <label>Public tags</label>
        <PublicTagSelect
          isEdit={false}
          onChange={async (publicTags: string[]) => await this.onChangePublicTags(publicTags)}
          selectedPublicTags={publicTags?.join(',')}
          inputName='form-control qa-topic-creator-public-tags-input'
          canEndUserAddPublicTags
          iconSize={12}
          placeholder='Public tags'
        />
      </div>
    )
  }
}

export default PublicTags
